import {
  FiAward,
  FiBriefcase,
  FiCode,
  FiFileText,
  FiMessageSquare,
  FiUser,
} from 'react-icons/fi';

export const NAV_FILES = [
  { index: 0, filename: 'about.md', Icon: FiUser },
  { index: 1, filename: 'work-history.md', Icon: FiBriefcase },
  { index: 2, filename: 'technologies.md', Icon: FiCode },
  { index: 3, filename: 'achievements.md', Icon: FiAward },
  { index: 4, filename: 'recommendations.md', Icon: FiMessageSquare },
  { index: 5, filename: 'articles.md', Icon: FiFileText },
];

export function filenameForTab(index) {
  return NAV_FILES.find((file) => file.index === index)?.filename ?? 'about.md';
}

function humanizeStem(stem) {
  if (stem === 'about') return 'About Me';
  return stem
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function titleForTab(index) {
  const stem = filenameForTab(index).replace(/\.md$/, '');
  return humanizeStem(stem);
}
